import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "components/common/Breadcrumbs";
import useIsMobile from "components/hooks/useIsMobile";
import CreateLightningTaskForm from "components/delegation/CreateLightningTaskForm";

export default () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        margin: isMobile ? "" : "auto",
        maxWidth: "700px",
        padding: isMobile ? "20px" : "64px",
      }}
    >
      <Breadcrumbs
        breadcrumbs={[
          { name: "Home", link: "/" },
          { name: "Tools", link: "/tools" },
          { name: "Delegations", link: "/tools/delegations" },
        ]}
      />
      <Typography variant="display" sx={{ marginBottom: "24px" }}>
        Create lightning task
      </Typography>
      <CreateLightningTaskForm
        onCancel={() => navigate("/tools/delegations")}
        onCreated={() => navigate("/tools/delegations")}
      />
    </Box>
  );
};
